export default "__VITE_ASSET__IiiFlcOa__"